export default __webpack_public_path__ + "static/media/sponge.17515b44.PNG";